import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown'
import { FaRegTrashAlt } from 'react-icons/fa'

import {
  BtnIcon,
  CustomModal,
  InputNumeroDecimal,
} from '../../../../../../components'
import { tableCellCentered } from '../../../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../../store/actions/system.actions'
import useModalDesdobramentoFalta, { LOAD_MESSAGE } from './ModalDesdobramentoFaltaHook'
import { calculateVolumeAndUnits } from '../../../../../../services/util/volume-and-units.service'

function ModalDesdobramentoFalta({ show, falta, reasons, onClose, onSaved, dispatch }) {
  const { state, localDispatch } = useModalDesdobramentoFalta()

  useEffect(() => {
    if (show && falta) {
      localDispatch.onOpen(falta)
    }
  }, [show, falta])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.SAVING:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.executeSave(
          state.falta.falta_id,
          state.ocorrenciaOriginal,
          state.desdobramentos,
        )
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox('Desdobramento salvo com sucesso', null))
        localDispatch.resetState()
        onSaved()
        onClose()
        break
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  if (!falta) return null

  const showFrac = !falta.caixa_com_peso_variavel && Number(falta.unit_sku) > 0
  const volLabel = falta.un_agregadora || 'Vol.'
  const fracLabel = falta.un_fracionada || 'Frac.'

  return (
    <CustomModal
      header="Desdobramento Falta"
      isVisible={show}
      onClose={onClose}
      width={900}
    >
      {/* Informações da entrega no topo */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 30,
        padding: '10px 0',
        borderBottom: '1px solid #ddd',
        marginBottom: 20,
      }}>
        <div style={{ fontSize: 14 }}><strong>Ciclo:</strong> {falta.ciclo_id}</div>
        <div style={{ fontSize: 14 }}><strong>Identificador:</strong> {falta.identifier}</div>
        <div style={{ fontSize: 14 }}><strong>Código:</strong> {falta.product_code}</div>
        <div style={{ fontSize: 14 }}><strong>Produto:</strong> {falta.product_name}</div>
      </div>

      {/* Falta Original */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ marginBottom: 10, color: '#14B0BF' }}>Falta Original</h4>
        <DataTable value={[{ ...falta, _qteAtual: state.qteOriginalAtual }]}>
          <Column
            header={volLabel}
            style={tableCellCentered(100)}
            body={row => {
              const { volume } = calculateVolumeAndUnits(
                row._qteAtual,
                falta.unit_sku,
                falta.caixa_com_peso_variavel,
              )
              return <span style={{ fontWeight: 600 }}>{Math.abs(volume)}</span>
            }}
          />
          {showFrac && (
            <Column
              header={fracLabel}
              style={tableCellCentered(100)}
              body={row => {
                const { units } = calculateVolumeAndUnits(
                  row._qteAtual,
                  falta.unit_sku,
                  falta.caixa_com_peso_variavel,
                )
                return <span style={{ fontWeight: 600 }}>{Math.abs(units)}</span>
              }}
            />
          )}
          <Column
            header="Ocorrência"
            body={() => (
              <Dropdown
                style={{ width: '100%' }}
                optionLabel="name"
                value={state.ocorrenciaOriginal}
                options={reasons}
                onChange={({ value }) => localDispatch.onOcorrenciaOriginalChange(value)}
                placeholder="Selecione a Ocorrência"
              />
            )}
          />
        </DataTable>
      </div>

      {/* Formulário novo desdobramento */}
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: 12,
          marginBottom: 20,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ minWidth: 100 }}>
          <InputNumeroDecimal
            label={volLabel}
            value={state.novoVol}
            onChange={localDispatch.onNovoVolChange}
            decimalScale={0}
            width={90}
            marginTop={0}
          />
        </div>
        {showFrac && (
          <div style={{ minWidth: 100 }}>
            <InputNumeroDecimal
              label={fracLabel}
              value={state.novoFrac}
              onChange={localDispatch.onNovoFracChange}
              decimalScale={0}
              width={90}
              marginTop={0}
            />
          </div>
        )}
        <div style={{ minWidth: 280 }}>
          <label style={{ fontSize: '0.8rem', color: '#14B0BF', display: 'block', marginBottom: 3 }}>
            Ocorrência
          </label>
          <Dropdown
            style={{ width: '100%' }}
            optionLabel="name"
            value={state.novaOcorrencia}
            options={reasons}
            onChange={({ value }) => localDispatch.onNovaOcorrenciaChange(value)}
            placeholder="Selecione a Ocorrência"
          />
        </div>
        <button
          type="button"
          onClick={localDispatch.onDesdobrar}
          style={{
            padding: '6px 16px',
            background: '#14B0BF',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            height: 32,
          }}
        >
          Desdobrar
        </button>
      </div>

      {/* Tabela de Desdobramentos */}
      {state.desdobramentos.length > 0 && (
        <div style={{ marginBottom: 20 }}>
          <h4 style={{ marginBottom: 10, color: '#14B0BF' }}>Desdobramentos</h4>
          <DataTable value={state.desdobramentos}>
            <Column
              header={volLabel}
              style={tableCellCentered(100)}
              body={d => {
                const { volume } = calculateVolumeAndUnits(
                  d.qte_missing,
                  falta.unit_sku,
                  falta.caixa_com_peso_variavel,
                )
                return <span>{Math.abs(volume)}</span>
              }}
            />
            {showFrac && (
              <Column
                header={fracLabel}
                style={tableCellCentered(100)}
                body={d => {
                  const { units } = calculateVolumeAndUnits(
                    d.qte_missing,
                    falta.unit_sku,
                    falta.caixa_com_peso_variavel,
                  )
                  return <span>{Math.abs(units)}</span>
                }}
              />
            )}
            <Column
              header="Ocorrência"
              body={d => d.missing_reason ? d.missing_reason.name : '—'}
            />
            <Column
              header=""
              style={tableCellCentered(60)}
              body={(d, { rowIndex }) => (
                <BtnIcon onClick={() => localDispatch.onRemoverDesdobramento(rowIndex)}>
                  <FaRegTrashAlt color="red" size={18} />
                </BtnIcon>
              )}
            />
          </DataTable>
        </div>
      )}

      {/* Botão Salvar */}
      {state.desdobramentos.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <button
            type="button"
            onClick={localDispatch.onSalvar}
            style={{
              padding: '6px 16px',
              background: '#14B0BF',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Salvar
          </button>
        </div>
      )}
    </CustomModal>
  )
}

const mapStateToProps = () => ({})
export default connect(mapStateToProps)(ModalDesdobramentoFalta)
